import { render, staticRenderFns } from "./TechnicalSpecificationManual.vue?vue&type=template&id=baf1cef6&scoped=true&"
import script from "./TechnicalSpecificationManual.vue?vue&type=script&lang=js&"
export * from "./TechnicalSpecificationManual.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalSpecificationManual.vue?vue&type=style&index=0&id=baf1cef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf1cef6",
  null
  
)

export default component.exports